'use client'
import React from 'react'

import BottomSheet from '@/shared/components/BottomSheet'
import { Caption, Text } from '@/shared/components/typography'

type PurchaseNoticeProps = {
  isOpen: boolean
  onClick: () => void
  onSecondClick: () => void
  userInputs: {
    [key: string]: string
  }
}

const UserInfoCheck = ({ isOpen, onClick, onSecondClick, userInputs }: PurchaseNoticeProps) => {
  const imgSrc = {
    src: '/icons/light_icn_caution_blue_40.svg',
    alt: '주차번호 입력 안내',
    width: 40,
    height: 40
  }
  const bodyContent = (
    <div className="mb-[26px] mt-2 flex w-full flex-col gap-[34px]">
      <Text level="text3" color="text090">
        작성한 입력 정보를 다시 확인해주세요.
      </Text>
      <div className="flex flex-col gap-1 rounded-lg bg-020 px-4 py-5">
        <div>
          {Object.entries(userInputs).map(([key, value]) => (
            <div key={key} className="flex items-center justify-between">
              <Caption level="caption2" color="text070">
                {key}
              </Caption>
              <Caption level="caption2" color="text090">
                {value}
              </Caption>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
  return (
    <BottomSheet
      imgSrc={imgSrc}
      isOpen={isOpen}
      title="정보 저장 후 수정이 불가합니다."
      className="title2"
      onClose={onSecondClick}
      bodyContent={bodyContent}
      secondBtnText="취소"
      onSecondClick={onSecondClick}
      btnText="확인"
      onClick={onClick}
    />
  )
}

export default UserInfoCheck
